// extracted by mini-css-extract-plugin
export default {"card":"H5-z"};